/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  TextField,
  MenuItem,
  Button,
  IconButton,
  Checkbox,
  InputAdornment,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Drawer from "@mui/material/Drawer";
import style from "../../../styles/common/formModal.module.css";
import countries from "../../../../src/Pages/Masters/Roles and Permissions/Country.json";
import EditDialog from "../../../Components/Common/EditDialog";
import FileField from "../../../Components/Masters/FileField";
import formatTitleWithOptional from "../../Scope1/OptionalFeild";
import { useUser } from "../../../context/AuthContext";
import Multiline from "../../../Components/Masters/Multiline";
import {
  getPurchaseDateRangeError,
  PURCHASE_DATE_MIN,
  todayLocalYYYYMMDD,
} from "../../../utils/validateFields";

const QUANTITY_UNIT_OPTIONS = ["Tonnes", "Units"];

const Form = ({
  isOpen,
  onClose,
  onSubmit,
  header,
  initialData,
  isEditing,
  defaultValue,
  id,
}) => {
  const { user } = useUser();

  const initialFormData = {
    purchaseDate: initialData?.purchaseDate || "",
    capitalGoodsName: initialData?.capitalGoodsName || "",
    capitalGoodsCategory: initialData?.capitalGoodsCategory || "",
    supplierName: initialData?.supplierName || "",
    quantity:
      initialData?.quantity === "-"
        ? ""
        : typeof initialData?.quantity === "object"
          ? initialData?.quantity?.value || ""
          : initialData?.quantity || "",
    quantityUnit:
      initialData?.quantityUnit ||
      (typeof initialData?.quantity === "object" ? initialData?.quantity?.unit : "") ||
      "",
    weightOfCapitalGoodsUnit: "Kg",
    cost: initialData?.cost || "",
    country: initialData?.country || "",
    weightOfCapitalGoods: initialData?.weightOfCapitalGoods || "",
    usefulLife: initialData?.usefulLife || "",
    country: Array.isArray(initialData?.country)
      ? initialData?.country[0] || ""
      : initialData?.country || "",
    materialComposition: initialData?.materialComposition || "",
    description: initialData?.description || "",
    documents: initialData?.documents || [],
    editRemarkReason: initialData?.editRemarkReason || "",
  };
  const [editDialog, setEditDialog] = useState(false);
  const fieldConfig = [
    {
      label: "Purchase Date",
      name: "purchaseDate",
      type: "date",
      required: true,
    },
    {
      label: "Capital Goods Category",
      name: "capitalGoodsCategory",
      type: "select",
      placeholder: "Select",
      required: true,
      options: [
        "Machinery and industrial equipment",
        "Manufacturing equipment",
        "IT equipment",
        "Buildings and infrastructure",
        "Vehicles",
        "Laboratory equipment",
        "Electrical equipment",
        "Office furniture",
        "Construction materials"
      ],
    },
    {
      label: "Name of the Capital Good",
      name: "capitalGoodsName",
      type: "text",
      placeholder: "Name",
      required: true,
    },
    {
      label: "Vendor/Supplier Name",
      name: "supplierName",
      type: "text",
      placeholder: "Activity Name",
      required: true,
    },
    {
      label: "Quantity Purchased",
      name: "quantity",
      type: "number",
      placeholder: "Enter no.",
      required: true,
      options: QUANTITY_UNIT_OPTIONS,
    },
    {
      label: "Total Cost (in USD)",
      name: "cost",
      type: "number",
      placeholder: "Enter no.",
      required: true,
    },
    {
      label: "Useful Life (Years) (optional)",
      name: "usefulLife",
      type: "number",
      placeholder: "Enter Years",
      required: false,
    },
    {
      label: "Country of Manufacture",
      name: "country",
      type: "select",
      placeholder: "Select",
      required: true,
      options: countries?.countries?.map((country) => country.name),
    },
    {
      label: "Material Composition (optional)",
      name: "materialComposition",
      type: "text",
      placeholder: "Enter material composition",
      required: false,
    },
    {
      label: "Weight of Capital Good (optional)",
      name: "weightOfCapitalGoods",
      type: "number",
      placeholder: "Enter quantity",
      required: false,
    },
    {
      label: "Remark (optional)",
      name: "description",
      type: "multiline",
      placeholder: "Brief",
      required: false,
    },
    {
      name: "editRemarkReason",
      type: "multlyline",
      placeholder: "Additional edit remarks",
      require: true,
    },
    {
      name: "document",
      type: "docs",
      placeholder: "Enter Document",
    },
  ];

  const initialErrors = {};

  const [formData, setFormData] = useState(initialFormData);
  const [formData2, setFormData2] = useState(initialFormData);
  const [errors, setErrors] = useState(initialErrors);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [uploadProgress, setUploadProgress] = useState({});

  useEffect(() => {
    setUploadedFiles(initialData?.documents || []);
    setFormData(initialFormData);
    setFormData2(initialFormData);
    setErrors({});
  }, [id, initialData]);

  const handleExitAgree = () => {
    setEditDialog(false);
    setErrors({});
    setFormData(initialFormData);
    setFormData2(initialFormData);
    onClose();
  };
  const validateFormData = () => {
    const newErrors = {};
    fieldConfig.forEach((field) => {
      if (!field.required) {
        return;
      }

      const value = formData[field.name];
      const missingRequired =
        field.type === "select"
          ? !value || value === "Tap to select"
          : !value;
      if (field.type !== "docs" && missingRequired) {
        newErrors[field.name] = `${field.label} is required.`;
      }

      if (field.type === "number" && value && value < 0) {
        newErrors[field.name] = `${field.label} must be a positive number.`;
      }

      if (field.type === "date" && value && isNaN(new Date(value).getTime())) {
        newErrors[field.name] = `${field.label} is an invalid date.`;
      }
      if (formData?.editRemarkReason === "") {
        if (user?.endUser && isEditing) {
          newErrors.editRemarkReason = "Edit remark is required";
        }
      }
    });

    if (formData.quantity && !formData.quantityUnit) {
      newErrors.quantityUnit = "Unit is required when quantity is entered.";
    }

    if (formData.weightOfCapitalGoods && !formData.weightOfCapitalGoodsUnit) {
      newErrors.weightOfCapitalGoodsUnit =
        "Unit is required when weight is entered.";
    }

    setErrors(newErrors);
    return Object.values(newErrors).every((error) => error === "");
  };
  const handleClose = () => {
    const isFormDataUnchanged = Object.keys(formData).every((key) => {
      const value1 = formData[key];
      const value2 = formData2[key];
      if (
        typeof value1 === "object" &&
        value1 !== null &&
        typeof value2 === "object" &&
        value2 !== null
      ) {
        return JSON.stringify(value1) === JSON.stringify(value2);
      }
      return value1 === value2;
    });

    if (isFormDataUnchanged) {
      handleExitAgree();
      setUploadedFiles([]);
      setFormData(initialFormData);
    } else {
      setUploadedFiles([]);
      setFormData(initialFormData);
      setEditDialog(true);
    }
  };

  const handleSubmit = () => {
    if (!validateFormData()) return;

    let formDataToSubmit = {
      ...formData,
      documents: uploadedFiles,
    };
    if (user?.endUser && isEditing) {
      formDataToSubmit.requestStatus = "edit";
      formDataToSubmit.requestMode = true;
      formDataToSubmit.approvalStatus = "Pending";
    }

    const purchaseDateError = getPurchaseDateRangeError(
      formDataToSubmit.purchaseDate
    );
    if (purchaseDateError) {
      setErrors((prev) => ({ ...prev, purchaseDate: purchaseDateError }));
      return;
    }

    onSubmit(formDataToSubmit, isEditing);
    setUploadedFiles([]);
  };

  const handleChange = (field, type) => (event) => {
    const { value } = event.target;
    if (type === "number" && value !== "" && !/^\d+(\.\d+)?$/.test(value))
      return;
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));

    setErrors((prev) => ({
      ...prev,
      [field]: "",
    }));
  };

  const handleMultiSelectChange = (field) => (event) => {
    const { value } = event.target;
    setFormData((prev) => ({
      ...prev,
      [field]: typeof value === "string" ? value.split(",") : value,
    }));

    setErrors((prev) => ({
      ...prev,
      [field]: "",
    }));
  };

  return (
    <Drawer
      sx={{
        backgroundColor: "transparent",
        "& .MuiDrawer-paper": {
          backgroundColor: "transparent",
          boxShadow: "none",
          height: "100vh",
          minHeight: "100vh",
          overflowY: "auto",
          overflowX: "hidden",
          display: "flex",
          flexDirection: "column",
        },
      }}
      anchor="right"
      open={isOpen}
      onClose={handleClose}
    >
      <Box
        sx={{
          width: "26rem",
          display: "flex",
          justifyContent: "space-between",
          gap: "1rem",
        }}
      >
        {editDialog && (
          <EditDialog {...{ editDialog, setEditDialog, handleExitAgree }} />
        )}
        <Box
          sx={{
            backgroundColor: "#fff",
            height: "20px",
            padding: "13px",
            margin: "30px 0 0 0",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderRadius: "80%",
            width: "5%",
            zIndex: "1",
          }}
        >
          <IconButton onClick={handleClose} sx={{ color: "black" }}>
            <CloseIcon sx={{ fontSize: "1.2rem" }} />
          </IconButton>
        </Box>
        <Box className={style.main_div}>
          <Typography
            id="modal-title"
            variant="h6"
            align="left"
            sx={{ textDecoration: "underline", fontWeight: "bold", mb: 2 }}
          >
            {header}
          </Typography>
          <form>
            {fieldConfig.map((field) => {
              return (
                <div key={field.name} style={{ margin: "1rem 0" }}>
                  <Typography
                    variant="subtitle1"
                    sx={{ fontWeight: "bold", mt: 1 }}
                  >
                    {formatTitleWithOptional(field.label)}
                  </Typography>

                  {user?.endUser && isEditing && field.type === "multlyline" ? (
                    <Multiline
                      title={formatTitleWithOptional("Edit Remark Reason")}
                      placeholder="Additional edit remarks"
                      fieldName="editRemarkReason"
                      value={formData.editRemarkReason}
                      handleChange={handleChange("editRemarkReason")}
                      errors={errors.editRemarkReason}
                    />
                  ) : null}

                  {
                    field.name === "quantity" ? (
                      <Box sx={{ display: "grid", gridTemplateColumns: "1fr 140px", gap: 1 }}>
                        <TextField
                          type="text"
                          size="small"
                          fullWidth
                          placeholder={field.placeholder || ""}
                          value={formData.quantity || ""}
                          onChange={handleChange("quantity", "number")}
                          error={Boolean(errors.quantity)}
                        />
                        <TextField
                          select
                          size="small"
                          fullWidth
                          value={formData.quantityUnit}
                          onChange={handleChange("quantityUnit")}
                          error={Boolean(errors.quantityUnit)}
                          SelectProps={{
                            displayEmpty: true,
                            renderValue: (selected) =>
                              selected && selected !== ""
                                ? selected
                                : "Select unit",
                          }}
                        >
                          <MenuItem value="" disabled>
                            Select unit
                          </MenuItem>
                          {(field.options || QUANTITY_UNIT_OPTIONS).map((option) => (
                            <MenuItem key={option} value={option}>
                              {option}
                            </MenuItem>
                          ))}
                        </TextField>
                        {errors.quantity || errors.quantityUnit ? (
                          <Typography
                            variant="body2"
                            color="#D34040"
                            sx={{ gridColumn: "1 / -1", marginLeft: "-0.2rem" }}
                          >
                            {errors.quantity || errors.quantityUnit}
                          </Typography>
                        ) : null}
                      </Box>
                    ) : field.name === "weightOfCapitalGoods" ? (
                      <Box>
                        <TextField
                          type="text"
                          size="small"
                          fullWidth
                          placeholder={field.placeholder || "Enter quantity"}
                          value={formData.weightOfCapitalGoods || ""}
                          onChange={handleChange("weightOfCapitalGoods", "number")}
                          error={Boolean(
                            errors.weightOfCapitalGoods || errors.weightOfCapitalGoodsUnit
                          )}
                          InputProps={{
                            endAdornment: (
                              <InputAdornment
                                position="end"
                                sx={{
                                  margin: 0,
                                  maxHeight: "none",
                                  height: "auto",
                                  alignSelf: "stretch",
                                }}
                              >
                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    alignSelf: "stretch",
                                    borderLeft: "1px solid rgba(0, 0, 0, 0.23)",
                                    pl: 1.25,
                                    pr: 1.25,
                                    minHeight: 40,
                                    ml: 0.5,
                                  }}
                                >
                                  <Typography
                                    component="span"
                                    variant="body2"
                                    sx={{
                                      color: "text.secondary",
                                      fontSize: "0.875rem",
                                      userSelect: "none",
                                    }}
                                  >
                                    Kg
                                  </Typography>
                                </Box>
                              </InputAdornment>
                            ),
                          }}
                          sx={{
                            "& .MuiOutlinedInput-root": {
                              paddingRight: 0,
                            },
                          }}
                        />
                        {errors.weightOfCapitalGoods || errors.weightOfCapitalGoodsUnit ? (
                          <Typography
                            variant="body2"
                            color="#D34040"
                            sx={{ mt: 0.5, marginLeft: "-0.2rem" }}
                          >
                            {errors.weightOfCapitalGoods || errors.weightOfCapitalGoodsUnit}
                          </Typography>
                        ) : null}
                      </Box>
                    ) : field.type === "text" ||
                      field.type === "date" ||
                      field.type === "number" ? (
                      <TextField
                        type={field.type === "date" ? "date" : "text"}
                        size="small"
                        fullWidth
                        placeholder={field.placeholder || ""}
                        value={formData[field.name] || field.defaultValue || ""}
                        onChange={handleChange(field?.name, field?.type)}
                        error={Boolean(errors[field.name])}
                        helperText={
                          <Typography
                            variant="body2"
                            color="#D34040"
                            sx={{ marginLeft: "-0.8rem" }}
                          >
                            {errors[field.name] || ""}
                          </Typography>
                        }
                        inputProps={
                          field.type === "date"
                            ? field.name === "purchaseDate"
                              ? {
                                  min: PURCHASE_DATE_MIN,
                                  max: todayLocalYYYYMMDD(),
                                }
                              : { max: todayLocalYYYYMMDD() }
                            : {}
                        }
                      />
                    ) : field.type === "multiline" ? (
                      <TextField
                        multiline
                        rows={4}
                        size="small"
                        fullWidth
                        placeholder={field.placeholder || ""}
                        value={formData[field.name] || ""}
                        onChange={handleChange(field?.name, field?.type)}
                        error={Boolean(errors[field.name])}
                        helperText={
                          <Typography
                            variant="body2"
                            color="#D34040"
                            sx={{ marginLeft: "-0.8rem" }}
                          >
                            {errors[field.name] || ""}
                          </Typography>
                        }
                      />
                    ) : field.type === "select" ? (
                      <TextField
                        select
                        size="small"
                        fullWidth
                        SelectProps={{
                          MenuProps: {
                            PaperProps: {
                              sx: {
                                maxWidth: "200px",
                                maxHeight: "200px",
                              },
                            },
                          },
                        }}
                        value={
                          formData[field?.name] || "Tap to select"
                        }
                        onChange={handleChange(field?.name)}
                        error={Boolean(errors[field.name])}
                        helperText={
                          <Typography
                            variant="body2"
                            color="#D34040"
                            sx={{ marginLeft: "-0.8rem" }}
                          >
                            {errors[field.name] || ""}
                          </Typography>
                        }
                      >
                        <MenuItem value="Tap to select" disabled>
                          {defaultValue || "Tap to select"}
                        </MenuItem>
                        {field.options.map((option) => (
                          <MenuItem key={option} value={option}>
                            {option}
                          </MenuItem>
                        ))}
                      </TextField>
                    ) : field.type === "multiselect" ? (
                      <TextField
                        select
                        SelectProps={{
                          multiple: true,
                          MenuProps: {
                            PaperProps: {
                              sx: {
                                maxWidth: "200px",
                                maxHeight: "300px",
                              },
                            },
                          },
                          renderValue: (selected) => {
                            if (selected.length === 0) {
                              return "Select";
                            }
                            return selected.join(", ");
                          },
                        }}
                        size="small"
                        fullWidth
                        value={formData[field?.name] || []}
                        onChange={handleMultiSelectChange(field?.name)}
                        error={Boolean(errors[field.name])}
                        helperText={
                          <Typography
                            variant="body2"
                            color="#D34040"
                            sx={{ marginLeft: "-0.8rem" }}
                          >
                            {errors[field.name] || ""}
                          </Typography>
                        }
                      >
                        {field.options?.map((option) => (
                          <MenuItem key={option} value={option}>
                            <Checkbox
                              checked={
                                (formData[field?.name] || []).indexOf(option) >
                                -1
                              }
                            />
                            {option}
                          </MenuItem>
                        ))}
                      </TextField>
                    ) : field.type === "docs" ? (
                      <FileField
                        title={formatTitleWithOptional(
                          "Upload Documents (optional)"
                        )}
                        name={field.name}
                        errors={errors[field.name]}
                        fileUrls={uploadedFiles}
                        progress={uploadProgress[field.name] || []}
                        {...{
                          setUploadedFiles,
                          setUploadProgress,
                          setErrors,
                        }}
                      />
                    ) : null}
                </div>
              );
            })}
          </form>

          <Button
            onClick={handleSubmit}
            variant="contained"
            sx={{ backgroundColor: "#1C486B", textTransform: "none" }}
          >
            Submit
          </Button>
        </Box>
      </Box>
    </Drawer>
  );
};

export default Form;
